module.exports = __webpack_public_path__ + "img/icon_landing_success@2x.f2d30199.png";